/* assets/nohtml-validation.js
   Global HTML validation & sanitization for Shopify themes
   - Blocks <, >, quotes, backticks on text-like inputs
   - Skips email/password/number/url/tel/search/date/time/color/range/file
   - Works on current and future fields (MutationObserver)
*/

(function () {
  'use strict';

  // Characters to block in text-like inputs (adjust if needed)
  var BLOCK_REGEX = /[<>\"'`]/;

  // Selector for text-like inputs (explicitly exclude types with built-in semantics)
  var TEXTY_SELECTOR = [
    'input:not([type])',
    'input[type="text"]',
    'input[type="search"]', // optional: include if you want to block symbols in search
    'textarea'
  ].join(',');

  // Types to skip (we do not pattern-validate these)
  var SKIP_TYPES = new Set([
    'email', 'password', 'number', 'url', 'tel',
    'date', 'datetime-local', 'month', 'week', 'time',
    'color', 'range', 'file', 'hidden', 'submit', 'button', 'checkbox', 'radio'
  ]);

  function isTextLike(el) {
    if (!el || el.disabled) return false;
    if (el.matches('textarea')) return true;

    if (el.tagName === 'INPUT') {
      var t = (el.getAttribute('type') || '').toLowerCase();
      if (!t) return true; // input with no type is text-like
      if (SKIP_TYPES.has(t)) return false;
      return t === 'text' || t === 'search'; // treat search as text-like (optional)
    }
    return false;
  }

  function markInvalid(el, message) {
    // Create or reuse an error node next to the field
    var id = el.id || ('input-' + Math.random().toString(36).slice(2));
    el.id = id;

    var errId = id + '-nohtml';
    var err = document.getElementById(errId);
    if (!err) {
      err = document.createElement('div');
      err.id = errId;
      err.className = 'form__field-error';
      err.setAttribute('role', 'alert');
      err.style.color = '#c62828';
      // Try to append near the input (fallback to parentNode)
      (el.closest('.field, .form__field, .form-group, .form__item') || el.parentNode || el).appendChild(err);
    }
    err.textContent = message || 'HTML is not allowed in this field.';

    el.setAttribute('aria-invalid', 'true');
    el.setAttribute('aria-describedby', err.id);
    el.classList.add('nohtml-invalid');
  }

  function clearInvalid(el) {
    el.removeAttribute('aria-invalid');
    var describedby = el.getAttribute('aria-describedby') || '';
    var ids = describedby.split(/\s+/);
    ids.forEach(function (id) {
      var node = document.getElementById(id);
      if (node && node.id.endsWith('-nohtml')) {
        node.parentNode && node.parentNode.removeChild(node);
      }
    });
    el.removeAttribute('aria-describedby');
    el.classList.remove('nohtml-invalid');
  }

  function validateValue(el) {
    var v = (el.value || '');
    // If it contains banned characters, flag as invalid
    if (BLOCK_REGEX.test(v)) {
      markInvalid(el);
      return false;
    }
    clearInvalid(el);
    return true;
  }

  function wireInput(el) {
    if (!isTextLike(el)) return;

    // Add an HTML5 pattern & title for native validation (nice tooltip on hover)
    // Pattern means: no < > " ' `
    el.setAttribute('pattern', '^[^<>"\'`]*$');
    el.setAttribute('title', 'HTML characters are not allowed: <, >, ", \', `');

    // Live validation while typing/pasting
    el.addEventListener('input', function () {
      validateValue(el);
    });

    // On blur, validate again (useful for autofill)
    el.addEventListener('blur', function () {
      validateValue(el);
    });
  }

  function scanAndWire(root) {
    var fields = (root || document).querySelectorAll(TEXTY_SELECTOR);
    fields.forEach(wireInput);
  }

  function preventSubmitIfInvalid(form) {
    form.addEventListener('submit', function (e) {
      // Validate all text-like inputs in this form
      var inputs = form.querySelectorAll(TEXTY_SELECTOR);
      var invalid = [];
      inputs.forEach(function (el) {
        if (isTextLike(el) && !validateValue(el)) {
          invalid.push(el);
        }
      });

      if (invalid.length) {
        e.preventDefault();
        // Focus the first invalid for accessibility
        invalid[0].focus();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Initial pass
    scanAndWire(document);

    // Observe future DOM changes (supports sections rendered later, modals, apps, etc.)
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return; // ELEMENT_NODE only
          if (node.matches && (node.matches(TEXTY_SELECTOR) || node.querySelector(TEXTY_SELECTOR))) {
            scanAndWire(node);
          }
          if (node.tagName === 'FORM' || (node.querySelector && node.querySelector('form'))) {
            var forms = node.tagName === 'FORM' ? [node] : node.querySelectorAll('form');
            forms.forEach(preventSubmitIfInvalid);
          }
        });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Attach submit guards to existing forms
    document.querySelectorAll('form').forEach(preventSubmitIfInvalid);
  });
})();